import $global from '@xt/client/store/global'
import { $service } from '@xt/client/experimental/request/service'
import lodash from 'lodash'
import moment from 'moment'

type BanList = {
  productId: number
}

class CourseBan {
  private banList: BanList[] = []
  private updateTime: number = 0
  private limitTime: number = 5

  public async getBanList(): Promise<Array<BanList>> {
    await this.refreshBanList()
    return this.banList
  }

  public async isBan(productId: string | number): Promise<boolean> {
    await this.refreshBanList()
    return lodash.isArray(this.banList) && this.banList.some(ban => ban.productId === productId)
  }

  private async refreshBanList(): Promise<void> {
    // 时间过期刷一次
    if (!this.isExpired()) {
      return
    }
    const [err, res] = await $service({
      url: `/mocks/ban_course_introduction.json`,
      baseURL: $global.production ? 'https://static.xuantong.cn' : 'https://testing-static.xuantong.cn'
    })
    if (err) return
    this.updateTime = Date.now()
    this.banList = Array.isArray(res.ban) ? res.ban : []
  }

  private isExpired(): boolean {
    if (this.updateTime == 0) {
      return true
    }
    if (moment(this.updateTime).add(this.limitTime, 'minutes').isBefore(moment(Date.now()))) {
      return true
    }
    return false
  }
}
export const courseBan = new CourseBan()
